import { Box, List, Skeleton, Stack } from "@mui/material";

export const SkillsListLoading = () => (
  <List
    aria-hidden="true"
    disablePadding
    sx={{ overflowY: "hidden", minHeight: 0, p: 0 }}
    data-testid="skills-list-loading"
  >
    {[
      {
        id: "skills-list-skeleton-row-1",
        titleWidth: "58%",
        descriptionWidth: "88%",
        metaWidth: "70%",
      },
      {
        id: "skills-list-skeleton-row-2",
        titleWidth: "70%",
        descriptionWidth: "80%",
        metaWidth: "62%",
      },
      {
        id: "skills-list-skeleton-row-3",
        titleWidth: "50%",
        descriptionWidth: "92%",
        metaWidth: "66%",
      },
      {
        id: "skills-list-skeleton-row-4",
        titleWidth: "64%",
        descriptionWidth: "76%",
        metaWidth: "58%",
      },
    ].map(({ id, titleWidth, descriptionWidth, metaWidth }) => (
      <Box
        component="li"
        key={id}
        sx={{
          alignItems: "flex-start",
          borderLeft: "3px solid transparent",
          display: "flex",
          gap: 1,
          m: 0,
          px: 2,
          py: 1.25,
        }}
        data-testid={id}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Stack direction="row" gap={1} alignItems="center">
            <Skeleton
              animation="wave"
              height={24}
              variant="text"
              width={titleWidth}
            />
            <Skeleton
              animation="wave"
              height={20}
              sx={{ flexShrink: 0 }}
              variant="rounded"
              width={52}
            />
          </Stack>
          <Stack gap={0.5} sx={{ mt: 0.5 }}>
            <Skeleton
              animation="wave"
              height={20}
              variant="text"
              width={descriptionWidth}
            />
            <Skeleton
              animation="wave"
              height={16}
              variant="text"
              width={metaWidth}
            />
          </Stack>
        </Box>
      </Box>
    ))}
  </List>
);
